import { checkUserRole } from '@/utils/roleUtils';
import { getUserRole, getUserID } from '@/utils/localStorageUtils';

export default async function ({ route, store, redirect, error, from, app }) {
    // Only set before route if it's different
    if (from.name !== route.name) {
        store.commit('setBeforeRouteName', route.name);
    }

    checkUserRole(store, redirect, route, error);

    const role = getUserRole();
    const userID = getUserID();

    if (role && role === 'registrar') {
        const blockStatus = await app.$axios.$get(`/registrars/${userID}/block-status`);

        if (store.getters.getBlockStatus === JSON.stringify(blockStatus)) {
            return;
        }

        if (blockStatus) {
            store.commit('setBlockStatus', blockStatus);
        }
    } else {
        if (store.getters.getBlockStatus === null) {
            return;
        }

        store.commit('setBlockStatus', null);
    }
}